import script from "./BillingDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./BillingDetailModal.vue?vue&type=style&index=0&id=bd7783d2&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd7783d2"]])

export default __exports__